<app-card
  [cardTitle]="'pages.change-password.label' | translate"
  [cardTitle]="'pages.change-password.title' | translate"
  [cardHelp]="'pages.change-password.help' | translate: {
    'minPasswordLength': minPasswordLengthText,
    'minPasswordUppercase': minPasswordUppercaseText,
    'minPasswordLowercase': minPasswordLowercaseText,
    'minPasswordDigits': minPasswordDigitsText,
    'minPasswordHistory': minPasswordHistoryText
  }">
</app-card>
